import React from "react";
import PageTitleBanner from "../../Components/Reusable/PageTitleBanner";
import { htmlToText } from "../../Utils/Utils";
import DataProvider from "../../Utils/DataProvider";

const TermsAndConditionsCoordinator = () => {
    return (
        <div className="d-flex flex-column mb-auto">
            <PageTitleBanner PageTitle={"Terms and Conditions"}    breadCrumpPageTitle={"Terms and Conditions"} />
            <div className="text-content-page-container d-flex flex-column align-items-center">
                <h2 className="Heading fw-600 mb-2 headingColor text-center">
                    Terms and Conditions
                </h2>

                <div className="d-flex flex-column w-100 gap-4">
                    {DataProvider.termsandconditon.map((value, index) => (
                        <h2 key={index} className="Sub-Heading mb-0">
                            <span className="headingColor Sub-Heading fw-600">{index + 1}. </span>
                            <span className="Sub-Heading fw-400 black mb-0">{htmlToText(value.text)}</span>
                        </h2>
                    ))}
                </div>
            </div>
        </div>
    );
};

export default TermsAndConditionsCoordinator;

